import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl
} from "@angular/forms";
import { AwsService } from "../../../providers/appsyncservice/aws.service";
import { UserTypePipePipe } from "../../../pipes/user-type-pipe.pipe";
import { positions } from "../../../models/positions";
declare var google: any;
import * as XLSX from "xlsx";
import * as jsPDF from "jspdf";

@Component({
  selector: "app-assigned-home",
  templateUrl: "./assigned-home.component.html",
  styleUrls: ["./assigned-home.component.css"]
})
export class AssignedHomeComponent implements OnInit {
  displayHouseValue: Number = 0;
  assignhouselist: any = [];
  emp_Data: any = [];
  house_modal: any = [];
  assignhouseFm: FormGroup;
  submitted = false;
  homeMaster: any = [];
  mode: any;
  isValid: any = true;
  errorMessage: any;

  statusData: any = [
    { id: 1, name: "ASSIGN" },
    { id: 2, name: "UNASSIGN" }
  ];


  sortKey: string = 'sno'; //set default
  sortReverse: boolean = false;

  noOfItems = 10;

  constructor(
    public awserviceProvider: AwsService,
    private formBuilder: FormBuilder
  ) {
    this.mode = "";
    this.getAllData();
  }

  // GET HOUSE MASTER FOR DROPDOWN
  getAllHouseData() {
    console.log("master Home");
    this.awserviceProvider.getUnAssignHouseList().then(data => {
      this.homeMaster = data;
      console.log("House-Master", this.homeMaster);
    });
  }

  // GET DATA
  getAllData() {
    console.log("GET HOUSE LIST");
    this.awserviceProvider.getAssignHouseList().then(data => {
      // this.assignhouselist = data;
      // console.log("response", data);
      this.constructData(data.filter(res => res.status === "ASSIGN"));
      // this.vendorData = data;
      console.log("assignhouselist", this.assignhouselist);
    });
  }

  constructData(data) {
    this.assignhouselist = []
    var oplist = []
    for (var i in data) {
      data[i].sno = +i + 1;
      oplist.push(data[i])
    }
    this.assignhouselist = oplist;
  }

  // Modal Open
  openStatus(hmid) {
    this.house_modal = [];
    console.log("home-hmid", hmid);
    this.awserviceProvider
      .homeIdFilter(hmid)
      .then(result => {
        console.log("Home details", result);
        this.house_modal = result;
      })
      .catch(err => {
        console.log("err", err);
      });
  }

  // ADD DATA
  add() {
    this.isValid = true;
    this.displayHouseValue = 1;
    this.errorMessage = "";
    this.mode = "add";
    this.emp_Data = [];
    this.formInitilization();
    this.getAllHouseData();
    console.log("this.assignhouseFm.value", this.assignhouseFm.value);
  }

  formInitilization() {
    // this.assignhouseFm = new FormGroup({
    //   id: new FormControl(""),
    //   rn_num: new FormControl(""),
    //   assigned_date: new FormControl(""),
    //   end_date: new FormControl(""),
    //   status: new FormControl("ASSIGN"),
    //   home_id: new FormControl("")
    // });
    this.assignhouseFm = this.formBuilder.group({
      id: [""],
      rn_num: [""],
      assigned_date: ["", Validators.required],
      // end_date: ["", Validators.required],
      status: ["ASSIGN"],
      home_id: ["", [Validators.required, Validators.min(1)]]
    });
  }

  get f() {
    return this.assignhouseFm.controls;
  }

  searchRnId() {
    if (this.assignhouseFm.value.rn_num !== "") {
      this.awserviceProvider
        .assignHomeFilter(this.assignhouseFm.value.rn_num)
        .then(result => {
          if (result.length === 0) {
            this.rnIdSearch();
            this.isValid = false;
          } else {
            this.emp_Data = [];
            this.isValid = true;
            this.errorMessage = "User already Exists!";
          }
        })
        .catch(err => {
          console.log("err", err);
        });
    } else {
      this.errorMessage = "Please Enter RN Number...";
    }
  }

  rnIdSearch() {
    this.emp_Data = [];
    console.log("searching.....", this.assignhouseFm.value.rn_num);
    this.awserviceProvider
      .rnUserFilter(this.assignhouseFm.value.rn_num)
      .then(result => {
        if (result.length === 0) {
          this.errorMessage = "Please Enter Valid RN Number...";
        } else {
          console.log("data-rn-user", result);
          this.errorMessage = "";
          this.emp_Data = result;
          console.log("EMP-data", this.emp_Data);
        }
      })
      .catch(err => {
        console.log("err", err);
      });
  }

  editformInitilization() {
    console.log("editformInitilization");
    this.assignhouseFm = this.formBuilder.group({
      id: [""],
      rn_num: [""],
      assigned_date: ["", Validators.required],
      end_date: [""],
      status: ["", [Validators.required, Validators.min(1)]],
      home_id: [""]
    });
  }
  editData(house) {
    console.log("house", house);
    this.displayHouseValue = 1;
    this.mode = "edit";
    this.isValid = false;
    this.errorMessage = "";
    this.editformInitilization();
    this.assignhouseFm.setValue({
      id: house.id,
      rn_num: house.rn_id,
      assigned_date: house.assigned_date,
      end_date: house.end_date || "",
      status: house.status,
      home_id: house.home_id
    });
  }
  // SAVE DATA
  onSubmit() {
    console.log("save isValid clicked");
    console.log("onSubmit.....", this.assignhouseFm.value);
    this.submitted = true;
    if (this.assignhouseFm.invalid) {
      return;
    }
    if (this.assignhouseFm.value.id !== "") {
      // UPDATE
      console.log("update");
      var test2 = {
        id: this.assignhouseFm.value.id,
        rn_id: this.assignhouseFm.value.rn_num,
        home_id: this.assignhouseFm.value.home_id,
        assigned_date: this.assignhouseFm.value.assigned_date,
        end_date:
          this.assignhouseFm.value.end_date === ""
            ? "0"
            : this.assignhouseFm.value.end_date,
        status: this.assignhouseFm.value.status
      };

      // # UPDATE RECORD #
      this.awserviceProvider
        .updateAssignHouse(test2)
        .then(result => {
          this.getAllData();
          this.displayHouseValue = 0;
          this.mode = "";
          this.isValid = true;
          console.log("update-result", result);
          this.updateMasterHome(test2);
        })
        .catch(err => {
          console.log("err", err);
        });
      console.log("update-record---", test2);
    } else {
      // CREATE
      var test1 = {
        user_pid: this.emp_Data[0].id, // user ID
        rn_id: this.emp_Data[0].user_name,
        home_id: this.assignhouseFm.value.home_id,
        assigned_date: this.assignhouseFm.value.assigned_date,
        /*
        end_date:
          this.assignhouseFm.value.end_date === ""
            ? "0"
            : this.assignhouseFm.value.end_date,
            */
        status: this.assignhouseFm.value.status,
        ex_data: 0
      };
      console.log("test1--", test1);
      // # CREATE RECORD #
      this.awserviceProvider
        .CreateAssignHouse(test1)
        .then(resultData => {
          this.getAllData();
          this.displayHouseValue = 0;
          this.mode = "";
          this.isValid = true;
          console.log("resultData-test", resultData);
          this.updateMasterHome(resultData[0]);
        })
        .catch(err => {
          console.log("err", err);
        });
    }
  }

  updateMasterHome(upData) {
    console.log("updateMasterHome", upData);
    this.awserviceProvider
      .updateMasterHouse(upData)
      .then(result => {
        console.log("updateMasterHome", result);
      })
      .catch(err => {
        console.log("err", err);
      });
  }

  // REFER FROM SC-USER-TRIP - (MASTER)
  deleteData(housedt) {
    this.awserviceProvider
      .deleteHouseData(housedt.id)
      .then(res => {
        this.getAllData();
      })
      .catch(err => {
        console.log(err);
      });
  }

  ngOnInit() {
    this.displayHouseValue = 0;
    this.mode = "";
    this.formInitilization();
    console.log("car data module init");
  }

  public sort(sortKey) {
    this.sortKey = sortKey;
    this.sortReverse = !this.sortReverse;
  }

  public sortClass(sortKey) {
    if (this.sortKey == sortKey) {
      if (this.sortReverse) {
        return 'fa fa-sort-desc';
      }
      else {
        return 'fa fa-sort-asc';
      }
    }
    else {
      return 'fa fa-sort';
    }

  }

}
